import React from 'react';

import { Inject } from '@odinjs/odin';

import { DeckAPI, DeckValue, FetchAPI, ModalProps, Stamp, StampIcon } from '@philips-emr/tws-components';
import { Color, ModalButtonType, ThemeTonalRange } from '@philips-emr/tws-constants';
import Controller, { OnDynamicContentRender, OnSelectItem } from '@philips-emr/tws-core/lib/client';
import { RenderEvent, SelectItemEvent } from '@philips-emr/tws-core/lib/component/types';
import { HttpService, ModalService } from '@philips-emr/tws-core/lib/services';

import { ConsentimentosAliases, FragmentNames } from '../../codegen';
import { Endpoints } from '../../definitions/endpoints';
import { ToastService } from '../../services';
import BaseController from '../base/base-controller';

enum Status {
  A = 'A',
  R = 'R',
}

@Controller({ fragment: FragmentNames.CONSENTIMENTOS })
export default class ConsentimentosController extends BaseController {

  @Inject(ConsentimentosAliases.FETCH)
  private fetch: FetchAPI;

  @OnDynamicContentRender(ConsentimentosAliases.CUSTOM_CARD_CONSENTIMENTOS)
  onDynamicContentRender({ data, render }: RenderEvent): void {
    const { ieStatus, dsStatus } = data as { ieStatus: Status, dsStatus: string };

    const props = {
      [Status.A]: { icon: StampIcon.CHECK, color: Color.SAFETY_GREEN },
      [Status.R]: { icon: StampIcon.CANCELED_OUTLINE, color: Color.SAFETY_ORANGE },
    };

    render(() => <Stamp {...props[ieStatus]} label={dsStatus} />);
  }

  @OnSelectItem(ConsentimentosAliases.DECK)
  onSelectItem({ item, target }: SelectItemEvent<DeckValue>): void {
    const api = target as DeckAPI;
    api.unselectAll();

    const { nrSeqBeneficiario } = this.context.getBulkData();
    const { nrSeqTermo, tipoTermo } = item;

    void HttpService.get<{ termo: string, ieRevogar: string }>(Endpoints.GET.ADITIVO_CONTRATUAL, { nrSeqBeneficiario, nrSeqTermo })
      .then(({ body }) => {
        if (body) {
          const { termo, ieRevogar } = body;

          const modalProps = {
            closeable: true,
            theme: ThemeTonalRange.ULTRA_LIGHT,
            title: tipoTermo as string,
            children: (<div style={{ wordWrap: 'break-word' }} dangerouslySetInnerHTML={{ __html: termo }} />),
          } as ModalProps;

          if (ieRevogar === 'S') {
            modalProps.dockButtons = [{
              action: () => this.recusar(nrSeqBeneficiario as number, nrSeqTermo as number),
              title: 'beneficiary.recusar',
              type: ModalButtonType.CANCEL,
            }];
          }

          ModalService.openDefault(modalProps);
        }
      })
      .catch(response => ToastService.open(response));
  }

  private recusar(nrSeqBeneficiario: number, nrSeqTermo: number): void {
    void HttpService.post(Endpoints.POST.ADITIVO_CONTRATUAL_RECUSAR, { nrSeqBeneficiario }, {
      body: {
        nrSeqTermo: nrSeqTermo,
        ieAcao: 'R',
      },
    })
      .then(() => this.fetch.forceFetch())
      .catch(response => ToastService.open(response));
  }
}
